export var MarketType;
(function (MarketType) {
    MarketType["Spot"] = "spot";
    MarketType["Derivative"] = "derivative";
})(MarketType || (MarketType = {}));
export var GridStrategyType;
(function (GridStrategyType) {
    GridStrategyType["Geometric"] = "geometric";
    GridStrategyType["Arithmetic"] = "arithmetic";
    GridStrategyType["Perpetual"] = "perpetual";
    // Trailing Arithmetic
})(GridStrategyType || (GridStrategyType = {}));
//# sourceMappingURL=trading.js.map